import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { RegistrationService } from '../../registration.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import { HandleError } from '../../shared/HandleError';

@Component({
  selector: 'app-Reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
  sainikDetails: any={};
  data: any;
  title = "Sainik Details";
  s:any={};
  
  constructor(private service: RegistrationService,private handleError:HandleError) {
    //this.sainikDetails={};
   // this.sainikDetails.Ranks={};
  }

  ngOnInit() {
  }

  GetSainikDetails(DI_District
    ,form: NgForm){
    this.data="";
    this.sainikDetails="";
    this.data = this.service.getSainikDetails(DI_District);
    this.data.subscribe(
      (response) => {
        this.sainikDetails=response;
        
      }, (error) => {
        console.log(error);
        if (error.status == 400){
        //swal('Warning!', 'Sainik does not exist.', 'warning');
        swal('Warning!', 'Sainik does not belong to this district.', 'warning');
        //window.location.reload();
        }
        this.handleError.ErrorHandler(error);
        // else if(error.status == 401)
        //   swal('Warning!', 'Not authorized to access this page.', 'warning');
        // else if (error.status == 440||error.status == 401) {
        //    localStorage.clear();
        //    this.change.emit(true);
        //    this.router.navigate(['/login']);
        //   swal({ title: 'Sorry', text: 'Your current session got expired! Please login again.', type: 'info'});
        // }

      });
  }
 
}



// WEBPACK FOOTER //
// ./src/app/sainik-registration/Reports/reports.component.ts